import React from "react";
import { getCarSetting } from "../../model/car";
import { commonErr } from "../common/errors";
import { LoadingInline } from "../common/loading";
import CarPaper from "./carpaper";

export default class CarSettingPapers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			papers: [],
		};
	}

	init = (carId) => {
		getCarSetting({
			carId,
		}).then((settingResp) => {
			if (settingResp.data.error >= commonErr.SUCCESS) {
				this.setState({
					err: settingResp.data.error,
					errMsg: settingResp.data.errorMessage,
					carId,
					papers: settingResp.data.data.papers,
				});
			} else {
				this.setState({
					// ...this.state,  //use in case err init, show list item carpaper: old state OR blank (curent:blank)
					err: settingResp.data.error,
					errMsg: settingResp.data.errorMessage,
					carId,
				});
			}
		});
	};

	componentDidMount() {
		const { car } = this.props;
		this.init(car.id);
	}

	componentWillReceiveProps(props) {
		this.state.err = commonErr.INNIT; //solve when click again slildebar at giaytoxe, during waiting time for response of axios getcarsetting: render loadingline instead of render old state
		const { car } = props;
		this.init(car.id);
	}

	render() {
		if (this.state.err === commonErr.INNIT) {
			return <LoadingInline />;
		} else {
			const { papers, carId } = this.state;
			return (
				<div className="content">
					<div className="content-container">
						{/* <h3 className="title">Giấy tờ xe</h3>
						<p>Giấy tờ dùng cho mục đích quản lý. Thông tin này tuyệt đối được bảo mật.</p>
						<div className="space m"></div> */}
						{papers.map((paper, i) => (
							<CarPaper
								key={i}
								paper={paper}
								carId={carId}
								tag={{
									//condition solve for last element no line in bottom
									lineTag: i !== papers.length - 1 ? <div className="line"></div> : "",
									spacemTag: i !== papers.length - 1 ? <div className="space m"></div> : "",
								}}
							/>
						))}
					</div>
				</div>
			);
		}
	}
}
